<template>
    <v-dialog v-model="dialog" persistent width="400">
        <div
            class="d-flex flex-column justify-center align-center elevation-15 higlight-type-content"
        >
            <div
                class="d-flex w-100 flex-column justify-center align-center position-relative pa-5"
            >
                <v-btn color="primary" icon class="position-absolute btn-cls" @click="close">
                    <v-icon color="primary">mdi-close-circle</v-icon>
                </v-btn>
                <div class="h-type-img w-90 d-flex flex-row justify-start align-center">
                    <img :src="markierImg" alt="icono de marcador" />
                    <span class="primary--text font-size-24">{{ $t('bookReading.notes') }}:</span>
                </div>
                <div class="w-100 d-flex flex-column justify-center align-center">
                    <v-row class="w-100">
                        <v-col cols="12">
                            <v-textarea
                                data-cy="noteModal-input-text"
                                outlined
                                rows="4"
                                auto-grow
                                class="border-radius-2 white font-size-16"
                                hide-details
                                name="txt_note"
                                color="primary"
                                v-model="noteContent"
                                :label="`${$t('bookReading.notes_modal_msg')}:`"
                            ></v-textarea>
                        </v-col>
                    </v-row>
                </div>
                <v-card-actions class="d-flex justify-center align-center">
                    <v-spacer></v-spacer>
                    <v-btn
                        data-cy="noteModal-save-button"
                        color="secondary"
                        class="px-16 py-5"
                        rounded
                        :loading="btnLoaded"
                        @click="saveNote"
                    >
                        {{ $t('save') }}
                    </v-btn>
                </v-card-actions>
            </div>
        </div>
    </v-dialog>
</template>
<script>
/* eslint-disable global-require */

export default {
    props: {
        dialog: { type: Boolean, default: false },
    },
    data() {
        return {
            btnLoaded: false,
            markierImg: require('@/assets/img/icons/reading/icon-notes-2.svg'),
            noteContent: '',
        }
    },
    methods: {
        close() {
            this.$emit('close-modal')
        },
        saveNote() {
            this.$emit('save-note')
        },
        resetVars() {
            this.noteContent = ''
            this.btnLoaded = false
        },
    },
}
</script>
<style>
.h-type-img {
    z-index: 300;
}
.h-type-img img {
    height: 5vh;
    z-index: 10;
}
.higlight-type-content {
    border-radius: 26px;
    background: #e2f3f2;
}
.h-type {
    background: white;
    border: 1.5px solid #514773 !important;
}

.h-type:hover {
    background: rgb(216, 216, 216);
    cursor: pointer;
}

.h-type.active {
    border: 3px solid #514773 !important;
}

.btn-cls {
    top: 1vh;
    right: 1vh;
}
</style>
